import React, { useEffect, useMemo, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import getFormStatus from '@/Form/Functions/getFormStatus'

import ArticleSlideCard from '@/Home/ArticleSlideCard'
import Slider           from '@/Slider'

import ajaxRequest from '@function/ajax/ajaxRequest'

import bemit from '@function/bemit'

export default function HomeAdSlider ({ role, ...props })
{
	const [status, setStatus] = useState({ });
	const [articles, setArticles] = useState([]);
	const [window_size, setWindowSize] = useState(String(window.innerWidth));

	const is__member = ['Membre de CE', 'Administrateur de CE'].includes(role);
	const is__admin  = role === 'Membre de synergies';

	useEffect(function ()
	{
		(async function ()
		{
			try
			{
				var response = await ajaxRequest('/front/fetch-ad-slider',
				{
					data: { limit: getArticlesLimit() }
				});
			}
			catch (update)
			{
				setStatus(update);
			}

			setArticles(response.articles || []);
		})();
	},
	[window_size]);

	useEffect(function ()
	{
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);

		function handleResize () { setWindowSize(String(window.innerWidth)); }
	},
	[]);

	const elements = useMemo(function ()
	{
		const articles_cards = articles.map(function (article)
		{
			return (
				<ArticleSlideCard article={ article } key={ article.id }
					type="ad" bemit={ ['side-of-video'] }
				/>
			);
		});

		const articles_per_slide = getArticlesPerSlide();

		return Array.from({ length: getMaxSlidesCount() })
		.map(function (_v, i)
		{
			const range_start = i * articles_per_slide;

		// ex : slider [ [1 2 3] [4 5 6] [7 8 9] ] <- il y a trois ranges
			const slide_range = [range_start, range_start+articles_per_slide];

			const slide =
			{
				id: uniqid()
			};

		// il n'y a plus d'article à partir de cette range
			if (!articles[i]) return null;

		// ex : [4, 5, 6] <- index des articles, vide si plus grand que le nombre
		// d'articles (il peut y avoir 4 mais pas 5 ni 6)
			slide.content = Array.from({ length: articles_per_slide })
			.map(function (_v, k)
			{
				const card = articles_cards[slide_range[0] + k];

				if (!card) // placeholder, évite le flex-grow ou utiliser grid
				{
					return (
						<div className={ bemit('c-model-preview-item',
							['blog', 'slider', 'ad']) }
							key={ uniqid() }
						/>
					);
				}

				return (
					<div key={ uniqid() } className="u-flex u-full-width">
						{ card }
					</div>
				);
			});

			return slide;
		})
		.filter(item => item !== null);
	},
	[articles]);

	if (!is__admin && !is__member && !props.force) return null;

	if (!elements.length) return null;

	return (
		<div className="dashboard-list u-margin-top-0">

			<div className="c-title c-title--v2 u-margin-top-20">
				<h2 className="c-title__txt">
					En ce moment
				</h2>
			</div>

			<Slider key={ window_size }
				type="custom"
				elements={ elements }
				bemit={ ['highlighted-blog', 'ad-blog',
					'multiple', 'side-of-video'] }
				hide-progress
			/>

			{ getFormStatus(status) }

		</div>
	);
}

function getArticlesPerSlide ()
{
	return window.innerWidth > 1400 ? 5
	: window.innerWidth >= 1024 ? 4
	: window.innerWidth >= 768 ? 3
	: 1;
}

function getArticlesLimit ()
{
	return window.innerWidth > 1400 ? 5 * 3
	: window.innerWidth >= 1024 ? 4 * 3
	: window.innerWidth >= 768 ? 3 * 4
	: 1 * 8;
}

function getMaxSlidesCount ()
{
	const articles_per_slide = getArticlesPerSlide();
	const articles_limit = getArticlesLimit();

	return Number((articles_limit / articles_per_slide).toFixed(0));
}
